import React, { Fragment, Component } from 'react';
import PropTypes from 'prop-types';
import { reduxForm } from 'redux-form';
import { BannerComponent, CardList, LevelNav } from 'common/components';
import { ROUTE_ACTIVITY_ADD } from 'common/constants';
import * as icons from 'common/svg/icons';
import { map } from 'actions';
import { push } from 'connected-react-router';
import { connect } from 'react-redux';
import * as constants from 'common/constants';
import mixpanel from 'mixpanel-browser';
import { ANALYTICS } from 'common/constants';
import { capitalizeString } from 'common/utils';

// TODO: should use constants too? (constants are messy now)
const typeList = [
  { label: 'Seeding', value: 'SEEDING', icon: icons.seeding },
  { label: 'Scouting', value: 'SCOUTING', icon: icons.scouting },
  { label: 'Fertilizing', value: 'FERTILIZING', icon: icons.fertilizer },
  { label: 'Spraying', value: 'SPRAYING', icon: icons.spray },
  { label: 'Harvesting', value: 'HARVESTING', icon: icons.tractor },
  { label: 'Storage', value: 'STORAGE', icon: icons.storagefill },
  { label: 'Delivery', value: 'DELIVERY', icon: icons.truck },
  { label: 'Other', value: 'OTHER', icon: icons.custom },
];

class LandingForm extends Component {
  render() {
    const { handleSubmit, onSubmit, onCancel } = this.props;

    return (
      <Fragment>
        <BannerComponent
          theme={['static', 'strong', 'large', 'mobile-fixed']}
          message={
            <LevelNav
              nav={{
                left: {
                  label: <span className={'visible--desktop'}>Back</span>,
                  action: () => onCancel(),
                },
                center: { label: 'Add An Activity' },
              }}
            />
          }
        />

        <form onSubmit={handleSubmit(onSubmit)}>
          <p className={'text--fade'}>
            <small>Select an activity from the list below to add.</small>
          </p>

          <CardList
            theme={['btn']}
            cards={
              typeList &&
              typeList.map(type => ({
                content: (
                  <Fragment>
                    <type.icon />
                    {type.label}
                  </Fragment>
                ),
                action: () => {
                  const formattedValue = capitalizeString(
                    type.value.toLowerCase()
                  );

                  mixpanel.track(constants.ANALYTICS.EVENTS.ACTIVITY.SELECTED, {
                    [ANALYTICS.PROPERTIES.ACTIVITY.TYPE]: formattedValue,
                  });
                  this.props.updateFormName('activityform');
                  this.props.goToActivity(type);
                },
              }))
            }
          />
        </form>
      </Fragment>
    );
  }
}

LandingForm.propTypes = {
  // from redux form
  error: PropTypes.string,
  handleSubmit: PropTypes.func.isRequired,
  valid: PropTypes.bool.isRequired,
  pristine: PropTypes.bool.isRequired,
  submitting: PropTypes.bool.isRequired,

  // manually added
  updateFormName: PropTypes.func,
  onCancel: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  goToActivity: PropTypes.func,
};

const formSettings = {
  form: 'activityform',
  // destroy values on leave
  forceUnregisterOnUnmount: true,
};

const mapDispatchToProps = {
  goToActivity: type => push(`${ROUTE_ACTIVITY_ADD}/${type.value}`),
  updateFormName: formName => map.updateFormName(formName),
};

export default reduxForm(formSettings)(
  connect(
    null,
    mapDispatchToProps
  )(LandingForm)
);



// WEBPACK FOOTER //
// ./src/containers/ActivityForm/forms/Landing.js